import React from "react";
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const LinkWrapper = styled.div`
display: flex;
justify-content: space-evenly;
border-bottom: .3px solid darkgray;
padding: 10px;
margin-bottom: 10px;
margin-top: 0;


`

const LinkTo = styled(Link)`
font-size: 30px;
font-family: "aktiv-grotesk", sans-serif;
font-weight: bolder;
/* font-family: 'Heebo', sans-serif; */
/* font-family: 'Nuosu SIL', serif; */
/* text-transform: uppercase; */
/* font-style: italic; */
text-decoration: none;
color: black;
padding: 10px;


&:hover {
  background-color: yellow;
  font-style: italic;
}

&:visited {
  color: black;
}

@media (min-width: 375px) and (max-width: 912px) {
  font-size: 15px;
  justify-content: center;
  font-family: "aktiv-grotesk", sans-serif;
}
`

const ToPost = () => {

  return(
    <LinkWrapper>
      <LinkTo to="/post">Photos</LinkTo>
      <LinkTo to="/contactme">Know Something?</LinkTo>
      <LinkTo to="/about">About me</LinkTo>
    </LinkWrapper>
  )
}

export default ToPost